export default __webpack_public_path__ + "static/media/time-box.da8ce689.svg";